import { patientConsultationsClient } from '@/api/patients/patientConsultationsClient';
import { QueryKey } from '@/data/query';

interface PatientConsultationsPageParams {
  size: number;
  after?: string;
  before?: string;
}

const queryClient = patientConsultationsClient();

interface UseGetPatientConsultationsParams {
  pageParams: PatientConsultationsPageParams;
  patientId?: number;
  search?: string;
  sort?: string;
}

export const useGetPatientConsultations = ({
  pageParams,
  patientId,
  search,
  sort,
}: UseGetPatientConsultationsParams) => {
  const queryResult = queryClient.listPatientConsultations.useQuery({
    queryKey: [QueryKey.GetPatientConsultations, pageParams, patientId, search, sort],
    queryData: {
      params: { id: Number(patientId) },
      query: { page: pageParams, search, sort },
    },
    enabled: Boolean(patientId),
  });
  return {
    data: queryResult.data?.body ?? null,
    isError: queryResult.isError,
    isSuccess: queryResult.isSuccess,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isPending: queryResult.isPending,
    refetch: queryResult.refetch,
  };
};
